import { memo } from "react";
import "./Searchbar.scss";
import classNames from "classnames";
import { SearchIcon } from "app/icons/navigation";

const Searchbar = ({ className, ...props }) => {
	const searchbarClassName = classNames("searchbar-input", className);

	return (
		<div className={searchbarClassName}>
			<SearchIcon width={20} className="searchbar-input__icon" />
			<input type="text" {...props} />
		</div>
	);
};

export default memo(Searchbar);
